import { Separator } from 'components/base/layout-components';
import {
  StyledSettingStatusBar,
  StyledSettingStatusChildren,
  StyledSettingStatusLogo,
  StyledSettingStatusText,
  StyledSettingStatusTitle
} from './SettingStatusBar.style';
import {
  getStatusBarViewConfig,
  statusBarDefaultConfig
} from './SettingStatusBar.utils';

const SettingStatusBar = ({
  logo,
  title,
  enabled,
  renderEnabled = 'Enabled',
  renderDisabled = 'Disabled',
  isLoading = false,
  children
}) => {
  const viewConfig = {
    ...statusBarDefaultConfig,
    ...getStatusBarViewConfig({
      isLoading,
      enabled,
      renderEnabled,
      renderDisabled
    })
  };

  return (
    <StyledSettingStatusBar backgroundColor={viewConfig.backgroundColor}>
      <StyledSettingStatusLogo src={logo} alt='' />
      <StyledSettingStatusTitle>{title}</StyledSettingStatusTitle>
      <Separator height='2rem' margin='0 2rem' />
      <StyledSettingStatusText>
        {viewConfig.Icon}
        {viewConfig.statusView}
      </StyledSettingStatusText>
      <StyledSettingStatusChildren>{children}</StyledSettingStatusChildren>
    </StyledSettingStatusBar>
  );
};

export default SettingStatusBar;
